import { createElement, lazy } from 'react';
import { Home } from '@/app/pages/Home';
import { loadedRoutes, routeLoaders, type RouteId } from '@/app/route-load';

function createRoutePage(id: RouteId) {
  const LazyPage = lazy(() => routeLoaders[id]().then((Component) => ({ default: Component })));

  function RoutePage() {
    const ready = loadedRoutes.get(id);
    if (ready) return createElement(ready);
    return <LazyPage />;
  }

  RoutePage.displayName = `RoutePage(${id})`;
  return RoutePage;
}

export { Home };
export const RosterPage = createRoutePage('roster');
export const BandDossierPage = createRoutePage('band');
export const ReleasesPage = createRoutePage('releases');
export const ReleaseDetailPage = createRoutePage('release');
export const MerchPage = createRoutePage('merch');
export const DossiersPage = createRoutePage('dossiers');
export const ContactPage = createRoutePage('contact');
export const LoginPage = createRoutePage('login');
